<template>
  <div class="c-selected-options">
    <div class="c-selected-options-item" v-for="(ModelItem,key) in ModelList" v-if="ModelItem.selected == true">
      <div class="c-selected-options-item-text">{{ModelItem.name}}</div>
      <div class="c-selected-options-item-close" v-on:click="SelectModel(key)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path fill="none" d="M0 0h32v32H0z"/>
            <path d="M16.2 15.5l5.1-5.1c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-5.1 5.1-5.1-5.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.1 5.1-5.1 5.1c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7l-5.3-5.1z"/>
        </svg>
      </div>
    </div>
    <div class="c-selected-options-item" v-for="(option,key) in Fueltype" v-if="option.selected == true">
      <div class="c-selected-options-item-text">{{option.name}}</div>
      <div class="c-selected-options-item-close" v-on:click="SelectFueltype(key)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path fill="none" d="M0 0h32v32H0z"/>
            <path d="M16.2 15.5l5.1-5.1c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-5.1 5.1-5.1-5.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.1 5.1-5.1 5.1c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7l-5.3-5.1z"/>
        </svg>
      </div>
    </div>
    <div class="c-selected-options-item" v-for="(option,key) in Geartype" v-if="option.selected == true">
      <div class="c-selected-options-item-text">{{option.name}}</div>
      <div class="c-selected-options-item-close" v-on:click="SelectGeartype(key)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path fill="none" d="M0 0h32v32H0z"/>
            <path d="M16.2 15.5l5.1-5.1c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-5.1 5.1-5.1-5.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.1 5.1-5.1 5.1c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7l-5.3-5.1z"/>
        </svg>
      </div>
    </div>
    <div class="c-selected-options-item" v-for="(option,key) in Transmissiontype" v-if="option.selected == true">
      <div class="c-selected-options-item-text">{{option.name}}</div>
      <div class="c-selected-options-item-close" v-on:click="SelectTransmissiontype(key)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path fill="none" d="M0 0h32v32H0z"/>
            <path d="M16.2 15.5l5.1-5.1c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-5.1 5.1-5.1-5.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.1 5.1-5.1 5.1c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7l-5.3-5.1z"/>
        </svg>
      </div>
    </div>
    <div class="c-selected-options-item" v-for="(option,key) in Price" v-if="option.selected == true">
      <div class="c-selected-options-item-text">Cena {{option.name}}</div>
      <div class="c-selected-options-item-close" v-on:click="SelectPrice(key)">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path fill="none" d="M0 0h32v32H0z"/>
            <path d="M16.2 15.5l5.1-5.1c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-5.1 5.1-5.1-5.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.1 5.1-5.1 5.1c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7l-5.3-5.1z"/>
        </svg>
      </div>
    </div>
    <div class="c-selected-options-remove" v-if="selectedCount > 0">
      <div class="c-selected-options-remove-close">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="nm-icon-erase" x="0px" y="0px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" xml:space="preserve">
        <g>
        	<rect x="0" fill="none" width="32" height="32"/>
        	<g>
        		<path d="M23.6,11.2l-1.5-2C22,9.1,21.8,9,21.7,9h-5V8h1V7h-3v1h1v1h-5c-0.2,0-0.3,0.1-0.4,0.2l-1.5,2c-0.1,0.2-0.1,0.4,0,0.5    C8.8,11.9,9,12,9.2,12h14c0.2,0,0.4-0.1,0.4-0.3C23.7,11.6,23.7,11.4,23.6,11.2z M10.2,11l0.8-1h10.5l0.8,1H10.2z"/>
        		<path d="M21.7,23.5c0,0.3-0.2,0.6-0.5,0.6h-10c-0.3,0-0.5-0.3-0.5-0.6V13h-1v10.5c0,0.9,0.7,1.6,1.5,1.6h10c0.8,0,1.5-0.7,1.5-1.6    V13h-1V23.5z"/>
        	</g>
        </g>
        </svg>
      </div>
      <div class="c-selected-options-remove-text">Skasuj&nbsp;wszystkie&nbsp;filtry</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectedOptions',
  props: [
    'ModelList',
    'Fueltype',
    'Geartype',
    'Transmissiontype',
    'Price'
  ],
  data: function () {
    return {
      selectedCount: 0
    }
  },
  methods: {
    SelectModel (key) {
      if (this.ModelList[key].selected == true) {
        this.ModelList[key].selected = false
      } else {
        this.ModelList[key].selected = true
      }
      this.$emit('ModelList', this.ModelList)
    },
    SelectFueltype (key) {
      if (this.Fueltype[key].selected == true) {
        this.Fueltype[key].selected = false
      } else {
        this.Fueltype[key].selected = true
      }
      this.$emit('Fueltype', this.Fueltype)
    },
    SelectGeartype (key) {
      if (this.Geartype[key].selected == true) {
        this.Geartype[key].selected = false
      } else {
        this.Geartype[key].selected = true
      }
      this.$emit('Geartype', this.Geartype)
    },
    SelectTransmissiontype (key) {
      if (this.Transmissiontype[key].selected == true) {
        this.Transmissiontype[key].selected = false
      } else {
        this.Transmissiontype[key].selected = true
      }
      this.$emit('Transmissiontype', this.Transmissiontype)
    },
    SelectPrice (key) {
      if (this.Price[key].selected == true) {
        this.Price[key].selected = false
      } else {
        this.Price[key].selected = true
      }
      this.$emit('Price', this.Price)
    }
  }
}
</script>

<style lang="scss">
  .c-selected-options{
    margin: 0 auto;
    max-width: 1177.6px;
    min-height: 80px;
    width: 92%;
    padding:2rem 0 0 0;
    // display:flex;
    &-item{
      background-color: #e7e9ea;
      margin-right: 15px;
      display: inline-block;
      margin-bottom: 15px;
      &-text{
        float: left;
        padding: 5px 15px;
      }
      &:hover{
        color:#c03;
        svg{
          fill: #c03;
        }
      }
      &-close{
        cursor: pointer;
        float: left;
        padding: 5px;
        background-color: #d5d5d5;
        font-weight: bold;
        line-height: 0;
        svg{
          width: 20px;
          height: 20px;
          fill: #000;
        }
      }
    }
    &-remove{
      margin-right: 15px;
      display: inline-block;
      margin-bottom: 15px;
      cursor: pointer;
      &-text{
        float: left;
        padding: 8px 15px 0 0;
      }
      &-close{
        float: left;
        font-weight: bold;
        line-height: 0;
        svg{
          width: 32px;
          height: 32px;
          fill: #000;
        }
      }
      &:hover{
        color:#c03;
        svg{
          fill: #c03;
        }
      }
    }
  }
</style>
